<template>
  <div>
    <div class="card">
      <div class="card-body">
        <keep-alive>
          <component
            :key="currentView.id"
            @loadTicket="loadTicket"
            v-if="currentView"
            :ticket="ticket"
            :attachments="attachments"
            v-bind:is="currentView.type"
            :step="currentView"
            @goto="setStep"
            @changeView="changeView"
          ></component>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import * as srcDoc from "srcdoc-polyfill";
import vue2Dropzone from "vue2-dropzone";
import axios from "axios";
import loginbusiness from "./loginbusiness.vue";
import loginretail from "./loginretail.vue";
import infodevice from "./infodevice.vue";
import indirizzoinfo from "./indirizzoinfo.vue";
import testo from "./testo.vue";
import anomalia from "./anomalia.vue";
import dataevento from "./dataevento.vue";
import indirizzoevento from "./indirizzoevento.vue";
import riepilogo from "./riepilogo.vue";
import infocorriere from "./infocorriere.vue";
import indirizzoedit from "./indirizzoedit.vue";
import buttons from "./buttons.vue";
import attachment from "./attachment.vue";
import codicesblocco from "./codicesblocco.vue";
import accaduto from "./accaduto.vue";
import ty from "./ty.vue";
import tyerror from "./tyerror.vue";
import danni from "./danni.vue";
import errordevice from "./errordevice.vue";
import devices from "./devices.vue";
import error from "./error.vue";
import stepheader from "./stepheader.vue";
import findmyphone from "./findmyphone.vue";
import errorfindmyphone from "./errorfindmyphone.vue";
import vue from "vue";
import Swal from "sweetalert2";
import vueFilterPrettyBytes from "vue-filter-pretty-bytes";
import checkgaranzia from "./checkgaranzia.vue";

vue.use(vueFilterPrettyBytes);
vue.component("buttons", buttons);
vue.component("infodevice", infodevice);
vue.component("testo", testo);
vue.component("vueDropzone", vue2Dropzone);
vue.component("stepheader", stepheader);
export default {
  name: "ticketwizard",

  props: {
    
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      templates: [],
      attachments: [],
      wizard: {},
      usersteps: [],
      currentView: null,
      ticket: null,
      history: [],
    };
  },
  components: {
    //vue2Dropzone,
    loginretail,
    loginbusiness,
    devices,
    infodevice,
    buttons,
    testo,
    anomalia,
    dataevento,
    indirizzoevento,
    attachment,
    indirizzoinfo,
    infocorriere,
    riepilogo,
    ty,
    tyerror,
    indirizzoedit,
    codicesblocco,
    accaduto,
    danni,
    errordevice,
    stepheader,
    error,
    findmyphone,
    errorfindmyphone,
    checkgaranzia
  },
  computed: {
    cuser() {
      return { roles: [] };
    },
    tinyKey: function () {
      return window.TinyApiKey;
    },
  },

  mounted() {
    setTimeout(this.loaddata, 200);
  },
  methods: {
    changeView: function (step) {
      this.currentView = step;
    },
    setStep: function (step) {
      if (step == "finish") {
        console.log("finish");
        return;
      }

      if (step == "back") {
        this.back();
        return;
      }
      console.log("setstep", step);
      var cw = this.wizard.steps.filter(
        (x) => x.id.toLowerCase() == step.toLowerCase()
      );
      if (cw.length > 0) {
        this.currentView = cw[0];
        this.history.push(cw[0]);
      }
    },
    back: function () {
      console.log("back",this.history,this.currentView);
      if (this.history.length > 1) {
        var a = this.history.pop();
        this.currentView = this.history[this.history.length - 1];
      }
    },
    loadTicket: function (nextstep) {
      axios.post(`tickets/wizard/new/${window.wizardType}`).then((response) => {
        if (response.data.code == 200) {
          this.ticket = response.data.data;
          this.setStep(nextstep);
        } else {
          var error = {
            "id": "errore",
            "type": "testo",
            "title": response.data.errormessages.join(", "),
            "subtitle": "",
            "alert": "",
            "alertcssclass": "",
            "buttons": []
          };
          this.currentView = error;
          // swal({
          //   title: "Qualcosa è andato storto",
          //   text: response.data.errormessages.join(", "),
          //   type: "error",
          //   showCancelButton: false,
          //   showConfirmButton: false,
          //   position: "bottom-top",
          // });
        }
      });
    },
    loaddata: function () {
      axios.defaults.headers['Authorization'] = `Bearer ${localStorage.getItem("srwizardtoken")}`;
      axios.post("tickets/wizards").then((response) => {
        this.templates = response.data;

        this.wizard = this.templates[window.wizardType];
        this.setStep(this.wizard.firstStep);
      });
    },
  },
};
</script>
